import WorkOrderAlertDiagnosticsRoute from '@/features/admin/work-order-alert-diagnostics/WorkOrderAlertDiagnosticsRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/general/alert-diagnostics')({
  component: WorkOrderAlertDiagnosticsRoute,
});
